import { gql } from '@apollo/client';

export default gql`
    {
        genres
    }
`;